<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card card-body">
        <template v-if="!hudury.enabled || hudury.status != 1">
            <div class="alert alert-danger text-center g">
                <h3>
                    قم بتفعيل الربط مع حضوري أولاً.
                </h3>
            </div>
        </template>
        <template v-if="hudury.enabled && hudury.status == 1">
            <div class="alert g" :class="hudury.online ? 'alert-success' : 'alert-warning'">
                <span class="text-dark" v-if="hudury.online"><i class="fa fa-check"></i> أداة مساعد حضوري متصلة الآن، سيُنفَّذ الطلب خلال دقيقتين.</span>
                <span class="text-dark" v-else><i class="fa fa-warning"></i> أداة مساعد حضوري غير متصلة — يُنفَّذ الطلب عند فتح صفحة حضوري في المتصفح المثبت عليه الأداة.</span>
            </div>
            <div class="form-group">
              <h5 for="">الفترة من</h5>
              <input type="date"
                class="form-control" v-model="from">
            </div>
            <div class="form-group">
              <h5 for="">الفترة الى</h5>
              <input type="date"
                class="form-control" v-model="to">
            </div>
            <div class="card-footer">
                <div class="g">
                    اختر المعلمين <a href="javascript:;" @click="selected=teachers.map(function(x){return x.number})"><u>
                        <i class="fa fa-check-square"></i> اختيار الكل</u></a>
                </div>
                <div class="g"><sort-select id="hudury-freedays-sort" v-model="sortTeachers" no-class></sort-select></div>
                <div style="width: 100%; border: solid 2px #333; padding: 5px; overflow-y: scroll; height: 350px;">
                    <div class="form-check" v-for="teacher in sortedTeachers" :key="teacher._id">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" v-model="selected" :value="teacher.number">
                        {{ teacher.name }}
                    </label>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="gett()">
                    استيراد الاجازات الآن
                </button>
            </div>
        </template>
    </div>
  </div>
</template>

<script>
import { sort_rows } from '@/libs/list-sort'
const axios = require("axios");
export default {
    data(){
        return {
      sortTeachers: '', // «ترتيب» (SortSelect): sorts the whole list
            user: JSON.parse(localStorage.getItem('user')),
            hudury: {
                enabled: false,
                status: 0,
                users: [],
                last_active: "--"
            },
            selected: [],
            teachers: [],
            from: new Date().toISOString().split("T")[0],
            to: new Date().toISOString().split("T")[0],
        }
    },
    created(){
        var g = this;
        $.post(api + '/user/teachers/hudury/settings', {
            jwt: g.user.jwt
        }).then(function(r){
            g.hudury = r.response
        })
        var _g = this, g = this;
        axios
        .post(api + "/user/teachers/list", {
            jwt: _g.user.jwt,
        })
        .then(function (r) {
            if (r.data.status == 200) {
            _g.$toast({
                component: ToastificationContent,
                props: {
                title: "حدث خطأ JWT",
                icon: "WarningIcon",
                variant: "danger",
                },
            });
            } else {
            _g.teachers = r.data.response;
            _g.loading = false;
            }
        })
        .catch(function () {
            _g.$toast({
            component: ToastificationContent,
            props: {
                title: "حدث خطأ",
                icon: "WarningIcon",
                variant: "danger",
            },
            });
        });
    },
  computed: {
    sortedTeachers() {
      return sort_rows(this.teachers, this.sortTeachers);
    },
  },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/teachers/hudury/import-freedays', {
                jwt: g.user.jwt,
                from: g.from,
                to: g.to,
                selected: g.selected
            }).then(function(r){
                if(r.status == 100){
                    alert("تم ارسال الطلب بنجاح، سيتم تنفيذه خلال دقيقتين من صفحة حضوري (يجب أن تكون صفحة حضوري مفتوحة مع أداة مساعد حضوري).", 100)
                }else{
                    alert(r.response, 200)
                }
            })
        }
        
    }
}
</script>

<style>

</style>